import './style';
import './style/main.scss'
import HomeContextProvider from "./context/HomeContext";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";
const RECAPTCHA_KEY = process.env.PREACT_APP_GOOGLE_RECAPTCHA_SITE_KEY || '6LczW9khAAAAAMkM1Pk02CWNqjAlkNCqoUV_mnmt'
export default () => <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY}><HomeContextProvider /></GoogleReCaptchaProvider>;
